export default __webpack_public_path__ + "static/media/Top institution.8370f58c.png";